import React from 'react';
import '../style/partners.css';

const partnerzy = [
  {
    nazwa: "REKORD SI Sp. z o.o.",
    link: "http://www.rekord.com.pl/",
  },
  {
    nazwa: "Asseco Poland S.A.",
    link: "http://pl.asseco.com/",
  },
  {
    nazwa: "Infor",
    link: "http://www.info-r.pl/",
  },
  {
    nazwa: "Clanet",
    link: "http://www.clanet.pl/",
  },
  {
    nazwa: "Ferro Backup System",
    link: "http://www.ferrobackup.com/pl/",
  },
];

const Partners = () => {
  return (
    <main className="partners-main">
      <h2>Nasi partnerzy</h2>
      <div className="partners-grid">
        {partnerzy.map((partner, index) => (
          <div className="partner-card" key={index}>
            <h3>{partner.nazwa}</h3>
            <a href={partner.link} target="_blank" rel="noopener noreferrer">
              {partner.link}
            </a>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Partners;